import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { satepsiApi } from '@/api/satepsi';
import { buildReportFootnotePlan, getSatepsiReferenceIds } from './footnotes';
import type { ReportData } from './types';

export function useReportFootnotes(data: ReportData) {
    const referenceIds = useMemo(() => getSatepsiReferenceIds(data), [data]);

    const { data: referencesResponse } = useQuery({
        queryKey: ['satepsi-references', referenceIds],
        queryFn: () => satepsiApi.references(referenceIds),
        enabled: referenceIds.length > 0,
        staleTime: 1000 * 60 * 60,
    });

    // Only the query is gated on having catalog ids: a report whose instruments
    // are all free has nothing to fetch but still has footnotes, and the plan
    // builder reads those off the blocks.
    return useMemo(
        () => buildReportFootnotePlan(data, referencesResponse?.references),
        [data, referencesResponse?.references],
    );
}
